import { LineType, VisualTitleLine } from 'modules/Documents/models/document';
import { VerifactuDisplayLine } from 'modules/Documents/models/verifactuDocument';

export const normalizeVerifactuDisplayLineToConcept = (
  line: VerifactuDisplayLine
): VisualTitleLine => {
  return {
    type: LineType.TITLE,
    text: line.text,
    order: line.order,
    groupName: line.groupName,
  };
};
